import { validationRegex } from "@obg/ngx.global";

const emailRegExp = new RegExp(validationRegex.email, "i");

/**
 * Validates an email address according to the RFC 5322 standard.
 */
export function isEmailValid(email: string): boolean {
	return emailRegExp.test(email);
}
